import React from "react";
import { useTranslation } from "react-i18next";
import "~/css/NetworkErrorModal.css";
import * as icon from "~/Icons";

interface NetworkErrorModalProps {
  show: boolean;
}

/**
 * ネットワークエラーモーダルコンポーネント
 * ネットワーク切断時に表示し、ページのリロード以外操作を受け付けない
 * @returns React.JSX.Element | null
 */
const NetworkErrorModal: React.FC<NetworkErrorModalProps> = ({ show }) => {
  const { t } = useTranslation();

  /**
   * ページをリロードする
   */
  const handleReload = () => {
    window.location.reload();
  };

  if (!show) {
    return null;
  }

  return (
    <div className="network-error-modal-overlay">
      <div className="network-error-modal-content">
        <div className="network-error-header">
          <h2>{t("networkErrorTitle")}</h2>
        </div>
        <div className="network-error-body">
          <div className="network-error-icon">
            <icon.icons_wifi_off className="network-error-icon-svg" />
          </div>
          <div className="network-error-message">
            <p>{t("networkErrorMessage1")}</p>
            <p>{t("networkErrorMessage2")}</p>
          </div>
        </div>
        <div className="network-error-footer">
          <button className="btn btn-danger network-error-reload-btn" onClick={handleReload}>
            {t("reload")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default NetworkErrorModal;
